import React, { useState } from 'react';
import { Home } from './pages/Home';
import { Library } from './pages/Library';
import { Globe } from './pages/Globe';
import { Navigation } from './components/Navigation';
import { MusicPlayer } from './components/MusicPlayer';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [isPlayerExpanded, setIsPlayerExpanded] = useState(false);
  // Mock currently playing track
  const currentTrack = {
    id: '1',
    title: 'Blinding Lights',
    artist: 'The Weeknd',
    album: 'After Hours',
    cover: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YWZ0ZXIlMjBob3Vyc3xlbnwwfHwwfHx8MA%3D%3D',
    tags: ['pop', 'synth', 'favorite'],
    location: {
      lat: 40.7128,
      lng: -74.006
    }
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home onExpandPlayer={() => setIsPlayerExpanded(true)} data-id="element-0" />;
      case 'library':
        return <Library data-id="element-1" />;
      case 'globe':
        return <Globe data-id="element-2" />;
      default:
        return <Home onExpandPlayer={() => setIsPlayerExpanded(true)} data-id="element-3" />;
    }
  };
  return <div className="flex flex-col h-screen w-full bg-black text-white" data-id="element-4">
      {/* Main content area */}
      <div className="flex-1 overflow-y-auto pb-20" data-id="element-5">{renderPage()}</div>
      {/* Music player (mini or expanded) */}
      <MusicPlayer track={currentTrack} isExpanded={isPlayerExpanded} onCollapse={() => setIsPlayerExpanded(false)} onExpand={() => setIsPlayerExpanded(true)} data-id="element-6" />
      {/* Bottom navigation */}
      {!isPlayerExpanded && <Navigation currentPage={currentPage} onNavigate={setCurrentPage} data-id="element-7" />}
    </div>;
}